<div id="app-navigation" [class.expanded]="!isSidebarCollapsed">
    <ng-container *ngFor="let navList of appNavigation; let i = index">
        <nav [id]="'app-navigation-section-' + i" class="nav-list">
            <ng-container *ngFor="let navItem of navList">
                <a
                    *ngIf="!navItem.submenu && !navItem.isHidden"
                    (mouseenter)="navItemHover(navItem.id, $event)"
                    [pTooltip]="isSidebarCollapsed ? (navItem.label | translate) : ''"
                    [href]="navItem.url"
                    [routerLinkActive]="['active-link']"
                    [routerLinkActiveOptions]="{ exact: false }"
                    [id]="navItem.id + '-nav-link'"
                    class="nav-link">
                    <ng-container
                        [ngTemplateOutlet]="navLink"
                        [ngTemplateOutletContext]="{ navItem: navItem }"></ng-container>
                </a>
                <button
                    *ngIf="navItem.submenu && !navItem.isHidden"
                    (click)="navItemClick(navItem)"
                    (mouseenter)="navItemHover(navItem.id, $event)"
                    [id]="navItem.id + '-nav-link'"
                    [class.active-link]="isRichMenuActive(navItem) || (navItem.id === 'my-orders' && isOnCheckMateUrl)"
                    class="nav-link">
                    <ng-container
                        [ngTemplateOutlet]="navLink"
                        [ngTemplateOutletContext]="{ navItem: navItem }"></ng-container>
                </button>

                <nav
                    [ngClass]="navItem.expanded ? 'submenu-expanded' : 'submenu-collapsed'"
                    class="submenu"
                    [id]="navItem.id + '-submenu'"
                    tabindex="-1">
                    <ng-container *ngFor="let submenuItem of navItem.submenu">
                        <a
                            *ngIf="submenuItem.internalRoute"
                            [routerLink]="submenuItem.url"
                            [routerLinkActive]="['active-submenu-link']"
                            [routerLinkActiveOptions]="{ exact: false }"
                            [id]="submenuItem.id + '-submenu-nav-link'"
                            [tabindex]="!navItem.expanded ? '-1' : '0'"
                            class="submenu-link">
                            <div class="btn-icon-dot" [id]="submenuItem.id + '-submenu-icon'">
                                <i class="fa-sharp fa-solid fa-circle-dot"></i>
                            </div>
                            <span class="nav-label" [id]="submenuItem.id + '-submenu-label'">{{
                                submenuItem.label | translate
                            }}</span>
                        </a>
                        <a
                            *ngIf="!submenuItem.internalRoute"
                            [href]="[submenuItem.url]"
                            [id]="submenuItem.id + '-submenu-nav-link'"
                            [tabindex]="!navItem.expanded ? '-1' : '0'"
                            class="submenu-link">
                            <div class="btn-icon-dot" [id]="submenuItem.id + '-submenu-icon'">
                                <i class="fa-sharp fa-solid fa-circle-dot"></i>
                            </div>
                            <span class="nav-label" [id]="submenuItem.id + '-submenu-label'">{{
                                submenuItem.label | translate
                            }}</span>
                        </a>
                    </ng-container>
                </nav>
            </ng-container>
        </nav>
    </ng-container>
</div>

<ng-template #navLink let-navItem="navItem">
    <div class="btn-icon" [id]="navItem.id + '-icon'">
        <i [class]="navItem.icon"></i>
    </div>
    <span class="nav-label" [id]="navItem.id + '-label'">{{ navItem.label | translate }}</span>
    <div *ngIf="navItem.submenu" class="expand-btn-container">
        <button
            [id]="navItem.id + '-expand-submenu-btn'"
            aria-label="Toggle menu"
            tabindex="-1"
            pButton
            class="p-button-rounded p-button-text expand-menu-btn p-button-secondary">
            <i class="fa-light" [ngClass]="navItem.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
        </button>
    </div>
</ng-template>

<p-overlayPanel #ovMyOrders styleClass="overlay" [style]="overlayStyle" [focusOnShow]="true">
    <div (mouseleave)="hideOverlays()" class="overlay">
        <div class="overlay-header">
            <p>{{ 'appNav.myOrders' | translate }}</p>
        </div>
        <div class="overlay-body">
            <ng-container *ngFor="let submenu of myOrdersSubmenu">
                <a *ngIf="!submenu.internalRoute" [href]="submenu.url" [id]="submenu.id"
                    ><div class="btn-icon-dot" [id]="submenu.id + '-submenu-icon-overlay'">
                        <i class="fa-sharp fa-solid fa-circle-dot"></i>
                    </div>
                    {{ submenu.label | translate }}</a
                >
                <a *ngIf="submenu.internalRoute" [routerLink]="submenu.url" [id]="submenu.id"
                    ><div class="btn-icon-dot" [id]="submenu.id + '-submenu-icon-overlay'">
                        <i class="fa-sharp fa-solid fa-circle-dot"></i>
                    </div>
                    {{ submenu.label | translate }}</a
                >
            </ng-container>
        </div>
    </div>
</p-overlayPanel>
